import { render, staticRenderFns } from "./data68.vue?vue&type=template&id=6caec485&scoped=true&"
import script from "./data68.vue?vue&type=script&lang=js&"
export * from "./data68.vue?vue&type=script&lang=js&"
import style1 from "./data68.vue?vue&type=style&index=1&id=6caec485&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caec485",
  null
  
)

export default component.exports